import { RepositoryFactory } from "../../api/RepositoryFactory";
import ApiErrorHandler from "@/_helpers/apiErrorHandler.js";

const ConnectorRepository = RepositoryFactory.get("connectors");

export const connectors = {
  namespaced: true,
  state: {
    connectors: [],
    templates: [],
    connector: {},
    status: {
      loading: false
    }
  },

  actions: {
    async getByCompany({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      var companyId = rootState.users.userCompany.companyId;

      await ConnectorRepository.getByCompany(user, companyId)
        .then(datas => {
          commit("SET_DATAS", datas.data);
        })
        .catch(res =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async createConnector(
      { dispatch, commit, rootState },
      { companyId, payload }
    ) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      if (companyId == undefined) {
        companyId = rootState.users.userCompany.companyId;
      }

      await ConnectorRepository.createConnector(user, companyId, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch(res =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async editConnector(
      { dispatch, commit, rootState },
      { connectorId, payload }
    ) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await ConnectorRepository.editConnector(user, connectorId, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch(res =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async deleteConnector({ dispatch, commit, rootState }, connectorId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await ConnectorRepository.deleteConnector(user, connectorId)
        .then(() => {
          commit("LOADING", false);
        })
        .catch(res =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getConnector({ dispatch, commit, rootState }, connectorId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await ConnectorRepository.getConnector(user, connectorId)
        .then(connector => {
          commit("SET_CONNECTOR", connector.data);
        })
        .catch(res =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getTemplates({ dispatch, commit, rootState }, active = true) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      await ConnectorRepository.templates(user, active)
        .then(datas => {
          commit("SET_TEMPLATES", datas.data);
        })
        .catch(res =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    }
  },

  mutations: {
    LOADING(state, status) {
      state.status.loading = status;
    },

    SET_DATAS(state, datas) {
      state.connectors = datas;
    },

    SET_TEMPLATES(state, datas) {
      state.templates = datas;
    },

    SET_CONNECTOR(state, data) {
      state.connector = data;
    }
  }
};
